import { http, common } from "@/utilities";

const baseUrl = process.env.VUE_APP_LOCATION_API_URL;
export default {
  search: (text) => {
    return http.getByParams({
      url: `${baseUrl}city/search`,
      params: { text },
    });
  },

  getCitiesOfState(stateId) {
    return http.get({
      url: `${baseUrl}city/${stateId}`,
    });
  },

  getStatesOfCountryByCountryId(countryId) {
    return http.get({
      url: `${baseUrl}state/country/${countryId}`,
    });
  },

  getStatesOfCountryByLocale(locale) {
    return http.get({
      url: `${baseUrl}state/locale/${locale}`,
    });
  },
};
